import { useController } from 'react-hook-form'

import { TextField } from '@mui/material'

const InputControlled = (props) => {
  const { name, control, rules, ...rest } = props

  const { field, fieldState: { error } } = useController({ name, control, rules })

  return (
    <TextField
      variant="standard"
      onChange={field.onChange}
      inputRef={field.ref}
      value={field.value || ''}
      name={field.name}
      error={!!error}
      helperText={error?.message}
      fullWidth
      {...rest}
    />
  )
}

export default InputControlled
